<template>
  <base-dialog
    :showDialog="showDialog"
    width="800"
    :scrollable="true"
    :fullscreen="fullScreen"
  >
    <template v-slot:body>
      <v-card>
        <v-card-text>
          <v-row class="mt-1">
            <v-col cols="12">
              <v-text-field
                outlined
                dense
                placeholder="Filtrar Fabricante"
                label="Fabricante"
                class="text caption ml-1"
                v-model="value"
                clearable
                append-icon="mdi-magnify"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <v-data-table
                dark
                dense
                hide-default-footer
                scrollable
                v-model="selected"
                show-select
                fixed-header
                :item-key="itemKey"
                :search="value"
                :headers="tableHeader"
                :items="manufacturerList"
                :items-per-page="manufacturerList.length"
                @dblclick:row="selectItem"
              >
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <form-buttons @goBack="$emit('goBack')" @submitForm="submitForm" />
      </v-card>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from '@/components/shared/base-dialog/BaseDialog'
import FormButtons from '@/components/shared/base-buttons/FormButtons'
import service from '@/services/manufacturer/ManufacturerService'
export default {
  components: {
    BaseDialog,
    FormButtons,
  },
  computed: {
    tableHeader() {
      const header = [
        { label: 'nome', text: 'Nome', value: 'NOME', show: true },
        {
          label: 'descMax',
          text: 'Desc. Max.',
          value: 'DESCONTOMAXIMO',
          show: true,
        },
        {
          label: 'descMaxA',
          text: 'Desc. Max. A',
          value: 'DESCONTOMAXIMOA',
          show: true,
        },
        {
          label: 'descMaxE',
          text: 'Desc. Max. E',
          value: 'DESCONTOMAXIMOE',
          show: true,
        },
        {
          label: 'descMaxE2',
          text: 'Desc. Max. E2',
          value: 'DESCONTOMAXIMOE2',
          show: true,
        },
        {
          label: 'descMaxE3',
          text: 'Desc. Max. E3',
          value: 'DESCONTOMAXIMOE3',
          show: true,
        },
        {
          label: 'idIntegracao',
          text: 'ID Integracao',
          value: 'IDINTEGRACAO',
          show: true,
        },
        {
          label: 'margemAtacado',
          text: 'Margem Atacado',
          value: 'MARGEMATACADO',
          show: true,
        },
        {
          label: 'margemEspecial',
          text: 'Margem Especial',
          value: 'MARGEMESPECIAL',
          show: true,
        },
        {
          label: 'margemEspecial2',
          text: 'Margem Especial2',
          value: 'MARGEMESPECIAL2',
          show: true,
        },
        {
          label: 'margemEspecial3',
          text: 'Margem Especial3',
          value: 'MARGEMESPECIAL3',
          show: true,
        },
        {
          label: 'margemVarejo',
          text: 'Margem Varejo',
          value: 'MARGEMVAREJO',
          show: true,
        },
      ]

      return header
    },
  },
  data: () => {
    return {
      fullScreen: false,
      manufacturerList: [],
      selected: [],
      value: '',
      itemKey: 'NOME',
    }
  },
  methods: {
    async requestManufacturers() {
      try {
        let response = await service.getManufacturers({ todos: 'S' })
        let dataList = response.data ?? response
        // this.manufacturerList = this.filterManufacturerList(dataList)
        this.manufacturerList = dataList
        // if(this.manufacturerList.length == 0)
        //     this.$toasted.info('Todas categorias já estão sincronizadas.')
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
    filterManufacturerList(manufacturerList) {
      if (manufacturerList.length > 0) {
        let newList = []
        manufacturerList.forEach((category) => {
          if (!category.IDINTEGRACAO > 0) newList.push(category)
        })
        return newList
      } else {
        return null
      }
    },
    selectItem(event, { item }) {
      let index = this.selected.findIndex(
        (value) => value[this.itemKey] == item[this.itemKey]
      )
      if (index != -1) this.selected.pop(index)
      else this.selected.push(item)
    },

    submitForm() {
      this.$emit('addItens', this.selected)
    },
  },
  mounted() {
    this.requestManufacturers()
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style></style>
